// extracted by mini-css-extract-plugin
module.exports = {"background":"MobileMenu_background__1JmT8","wrapper":"MobileMenu_wrapper__KEMc4","navLink":"MobileMenu_navLink__3cQMf"};